import { Api } from "../Config/request";

const addNewContact = async (data) => {
  let response = await Api.PostRequest("/contact", data);
  // console.log(response);
  return response;
};

const getContacts = async (data) => {
  let response = await Api.GetRequest("/contact", data);
  return response;
};

const getContactById = async (data) => {
  let response = await Api.GetRequest(`/contact/${data.id}`);
  return response;
};
const deleteContact = async (data) => {
  let response = await Api.DeleteRequest(`/contact/${data.id}`, data);
  return response;
};

const searchContact = async (query) => {
  try {
    console.log("INSIDE TRY BLOCK");
    console.log("QUERY",query);
    let response = await Api.GetRequest(`/contact${query}`);
    console.log("RESPONSE", response);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const updateContact = async (data) => {
  let response = await Api.PutRequest(`/contact/${data.id}`, data);
  return response;
};

const contactApi = { addNewContact, getContacts, deleteContact, updateContact, getContactById, searchContact };

export default contactApi;
